module.exports = __webpack_public_path__ + "img/C_mask.313b115f.png";